// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ==================== RENDER TASKS STYLES ==================== */
.tasks-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* Header Section */
  /* No Data State */
  /* ==================== TABLE VIEW ==================== */
  /* ==================== GRID VIEW ==================== */
}
.tasks-container .tasks-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.tasks-container .tasks-header .tasks-summary {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tasks-container .tasks-header .tasks-summary p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}
.tasks-container .tasks-header .tasks-actions-right {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}
.tasks-container .tasks-header .tasks-actions-right .view-toggles {
  display: flex;
  gap: 4px;
}
.tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn:hover {
  background-color: #f3f4f6;
}
.tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.tasks-container .tasks-header .tasks-actions-right .add-task-btn button {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.tasks-container .tasks-header .tasks-actions-right .add-task-btn button:hover {
  background: #0052a3;
}
.tasks-container .no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  border: 2px dashed #cbd5e1;
  min-height: 200px;
}
.tasks-container .no-data-container .no-data-title {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}
.tasks-container .no-data-container .no-data-message {
  font-size: 1rem;
  color: #6b7280;
  max-width: 400px;
  line-height: 1.5;
}
.tasks-container .table-responsive {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;
}
.tasks-container .table-responsive::-webkit-scrollbar {
  height: 6px;
}
.tasks-container .table-responsive::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}
.tasks-container .documents-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.tasks-container .documents-table thead {
  background-color: #f1f5f9;
}
.tasks-container .documents-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  font-size: 14px;
}
.tasks-container .documents-table thead th.td-th-casedet {
  font-size: 14px;
}
.tasks-container .documents-table tbody tr {
  transition: background-color 0.2s ease;
  cursor: pointer;
}
.tasks-container .documents-table tbody tr:hover {
  background-color: #f9fafb;
}
.tasks-container .documents-table tbody tr:not(:last-child) td {
  border-bottom: 1px solid #f1f5f9;
}
.tasks-container .documents-table tbody tr td {
  padding: 0.9rem 1rem;
  color: #374151;
  vertical-align: middle;
  font-size: 14px;
}
.tasks-container .documents-table tbody tr td.td-th-casedet {
  font-size: 14px;
}
.tasks-container .documents-table .editdel-table-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.tasks-container .documents-table .editdel-table-actions button {
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  width: 50px;
}
.tasks-container .documents-table .editdel-table-actions button.editbtn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.tasks-container .documents-table .editdel-table-actions button.delbtn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.tasks-container .tasks-grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 10px 2px;
}
.tasks-container .tasks-grid-layout .modern-task-card {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
  cursor: pointer;
  position: relative;
  /* Status Badge (Top-Right Corner) */
  /* Header Strip with Actions */
  /* Content Body */
}
.tasks-container .tasks-grid-layout .modern-task-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.tasks-container .tasks-grid-layout .modern-task-card .task-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 10px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.tasks-container .tasks-grid-layout .modern-task-card .task-badge.new {
  background-color: darkgreen;
}
.tasks-container .tasks-grid-layout .modern-task-card .task-badge.updated {
  background-color: darkcyan;
}
.tasks-container .tasks-grid-layout .modern-task-card .task-badge::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip {
  background-color: #f8fafb;
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 2px solid #e2e8f0;
  transition: background 0.3s ease;
  gap: 10px;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.4;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge .type-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge .title-text {
  word-break: break-word;
  color: var(--primary-color);
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill.new {
  background-color: #dcfce7;
  color: #166534;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill.updated {
  background-color: #e0f2fe;
  color: #075985;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
  margin-left: auto;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn.edit-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn.delete-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
  /* Horizontal Row for Two Items Side by Side */
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .recurring-info {
  background-color: #fff7ed;
  color: #c2410c;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px dashed #fdba74;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal {
  display: flex;
  gap: 12px;
  width: 100%;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal .detail-row-half {
  flex: 1 1;
  min-width: 0;
}
@media (max-width: 480px) {
  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal {
    flex-direction: column;
    gap: 8px;
  }
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6b7280;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-label .row-icon {
  font-size: 0.9rem;
  color: #9ca3af;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value {
  font-size: 0.9rem;
  color: #1f2937;
  font-weight: 500;
  padding-left: 2px;
  line-height: 1.5;
  word-break: break-word;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge.completed {
  background-color: #d1fae5;
  color: #047857;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge.pending {
  background-color: #fee2e2;
  color: #b91c1c;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text {
  color: #4b5563;
  max-height: 150px;
  overflow-y: auto;
  padding-right: 4px;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {
  width: 3px;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.8rem;
  margin-left: 5px;
  padding: 0;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {
  text-decoration: underline;
  color: var(--primary-color);
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text img {
  max-width: 100%;
  height: auto;
}
.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text p {
  margin: 0 0 4px 0;
}

/* Inline badge for table view */
.task-badge-inline {
  padding: 1px 5px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.task-badge-inline::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.task-badge-inline.new {
  background-color: darkgreen;
}
.task-badge-inline.updated {
  background-color: darkcyan;
}

/* ==================== ANIMATIONS ==================== */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes sparkle {
  0%, 100% {
    opacity: 0.5;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}
/* ==================== RESPONSIVE STYLES ==================== */
@media (max-width: 768px) {
  .tasks-container .tasks-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .tasks-container .tasks-header .tasks-actions-right {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }
  .tasks-container .tasks-grid-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip {
    padding: 12px 16px;
    flex-wrap: wrap;
    gap: 8px;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left {
    gap: 10px;
    flex-wrap: wrap;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge {
    font-size: 0.9rem;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions {
    gap: 6px;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn {
    width: 30px;
    height: 30px;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body {
    padding: 16px;
    gap: 12px;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal {
    flex-direction: column;
    gap: 8px;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text {
    max-height: 120px;
  }
  .tasks-container .documents-table {
    font-size: 0.85rem;
  }
  .tasks-container .documents-table thead th,
  .tasks-container .documents-table tbody td {
    padding: 0.75rem 0.5rem;
  }
}
@media (max-width: 480px) {
  .tasks-container .tasks-header .tasks-summary {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .tasks-container .tasks-header .tasks-actions-right {
    flex-direction: column;
    width: 100%;
  }
  .tasks-container .tasks-header .tasks-actions-right .view-toggles {
    width: 100%;
    justify-content: stretch;
  }
  .tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn {
    flex: 1 1;
  }
  .tasks-container .tasks-header .tasks-actions-right .add-task-btn {
    width: 100%;
  }
  .tasks-container .tasks-header .tasks-actions-right .add-task-btn button {
    width: 100%;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip {
    padding: 10px 14px;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left {
    width: 100%;
    justify-content: space-between;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge {
    font-size: 0.85rem;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal {
    flex-direction: column;
    gap: 8px;
  }
}
/* ==================== INTEGRATION WITH TAB-CONTENT ==================== */
/* These styles ensure proper integration when used within tab-content */
.tab-content .summary.header-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.tab-content .summary.header-actions-container .sum-amount {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tab-content .summary.header-actions-container .sum-amount p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}
.tab-content .summary.header-actions-container .actions-right {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles {
  display: flex;
  gap: 4px;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn:hover {
  background-color: #f3f4f6;
}
.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.tab-content .summary.header-actions-container .actions-right .tab-add {
  display: flex;
  justify-content: end;
}
.tab-content .summary.header-actions-container .actions-right .tab-add > button {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 6px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.tab-content .summary.header-actions-container .actions-right .tab-add > button:hover {
  background: #0052a3;
}
@media (max-width: 600px) {
  .tab-content .summary.header-actions-container {
    flex-direction: column;
    align-items: flex-start !important;
  }
  .tab-content .summary.header-actions-container .actions-right {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/style/RenderTasks.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,kEAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,mBAAA;EAsFA,kBAAA;EA2BA,yDAAA;EAuGA,wDAAA;AArNF;AAFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAIJ;AAFI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAIN;AAFM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAIR;AAII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAFN;AAIM;EACE,aAAA;EACA,QAAA;AAFR;AAIQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAFV;AAIU;EACE,eAAA;EACA,cAAA;AAFZ;AAKU;EACE,yBAAA;AAHZ;AAMU;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAJZ;AAUQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AARV;AAUU;EACE,mBAAA;AARZ;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;AAdJ;AAgBI;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAdN;AAiBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAfN;AAoBE;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;AAlBJ;AAoBI;EACE,WAAA;AAlBN;AAoBI;EACE,yBAAA;EACA,kBAAA;AAlBN;AAsBE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AApBJ;AAsBI;EACE,yBAAA;AApBN;AAsBM;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;AApBR;AAsBQ;EACE,eAAA;AApBV;AA0BM;EACE,sCAAA;EACA,eAAA;AAxBR;AA0BQ;EACE,yBAAA;AAxBV;AA2BQ;EACE,gCAAA;AAzBV;AA4BQ;EACE,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AA1BV;AA4BU;EACE,eAAA;AA1BZ;AAgCI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AA9BN;AAgCM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;EACA,WAAA;AA9BR;AAiCU;EACE,+BAAA;EACA,YAAA;AA/BZ;AAoCU;EACE,+BAAA;EACA,YAAA;AAlCZ;AA0CE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,iBAAA;AAxCJ;AA0CI;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EAOA,oCAAA;EAiCA,8BAAA;EA4FA,iBAAA;AAzKN;AAuCM;EACE,2BAAA;EACA,yCAAA;AArCR;AAyCM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AAvCR;AAyCQ;EACE,2BAAA;AAvCV;AA0CQ;EACE,0BAAA;AAxCV;AA2CQ;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AAzCV;AA8CM;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,gCAAA;EACA,SAAA;AA5CR;AA8CQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AA5CV;AA8CU;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA5CZ;AA8CY;EACE,iBAAA;EACA,cAAA;AA5Cd;AA+CY;EACE,sBAAA;EACA,2BAAA;AA7Cd;AAiDU;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AA/CZ;AAiDY;EACE,yBAAA;EACA,cAAA;AA/Cd;AAiDY;EACE,yBAAA;EACA,cAAA;AA/Cd;AAoDQ;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;AAlDV;AAoDU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAlDZ;AAqDc;EACE,+BAAA;EACA,YAAA;AAnDhB;AAwDc;EACE,+BAAA;EACA,YAAA;AAtDhB;AA8DM;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EAeA,8CAAA;AA1ER;AA6DQ;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;AA3DV;AA+DQ;EACE,aAAA;EACA,SAAA;EACA,WAAA;AA7DV;AA+DU;EACE,SAAA;EACA,YAAA;AA7DZ;AAgEU;EAVF;IAWI,sBAAA;IACA,QAAA;EA7DV;AACF;AAgEQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA9DV;AAgEU;EACE,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA9DZ;AAgEY;EACE,iBAAA;EACA,cAAA;AA9Dd;AAkEU;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAhEZ;AAkEY;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAhEd;AAkEc;EACE,yBAAA;EACA,cAAA;AAhEhB;AAkEc;EACE,yBAAA;EACA,cAAA;AAhEhB;AAoEY;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAlEd;AAoEc;EACE,UAAA;AAlEhB;AAoEc;EACE,yBAAA;EACA,kBAAA;AAlEhB;AAqEc;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AAnEhB;AAqEgB;EACE,0BAAA;EACA,2BAAA;AAnElB;AAwEc;EACE,eAAA;EACA,YAAA;AAtEhB;AAwEc;EACE,iBAAA;AAtEhB;;AAgFA,gCAAA;AACA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AA7EF;AA+EE;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AA7EJ;AAgFE;EACE,2BAAA;AA9EJ;AAiFE;EACE,0BAAA;AA/EJ;;AAmFA,yDAAA;AACA;EACE;IACE,UAAA;IACA,qBAAA;EAhFF;EAkFA;IACE,UAAA;IACA,mBAAA;EAhFF;AACF;AAmFA;EACE;IAEE,YAAA;IACA,qBAAA;EAlFF;EAoFA;IACE,UAAA;IACA,qBAAA;EAlFF;AACF;AAqFA,gEAAA;AACA;EAEI;IACE,sBAAA;IACA,uBAAA;EApFJ;EAsFI;IACE,cAAA;IACA,WAAA;IACA,8BAAA;EApFN;EAwFE;IACE,0BAAA;IACA,SAAA;EAtFJ;EAyFM;IACE,kBAAA;IACA,eAAA;IACA,QAAA;EAvFR;EAyFQ;IACE,SAAA;IACA,eAAA;EAvFV;EAyFU;IACE,iBAAA;EAvFZ;EA2FQ;IACE,QAAA;EAzFV;EA2FU;IACE,WAAA;IACA,YAAA;EAzFZ;EA8FM;IACE,aAAA;IACA,SAAA;EA5FR;EA8FQ;IACE,sBAAA;IACA,QAAA;EA5FV;EAgGU;IACE,iBAAA;EA9FZ;EAqGE;IACE,kBAAA;EAnGJ;EAqGI;;IAEE,uBAAA;EAnGN;AACF;AAwGA;EAGM;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAxGN;EA2GI;IACE,sBAAA;IACA,WAAA;EAzGN;EA2GM;IACE,WAAA;IACA,wBAAA;EAzGR;EA2GQ;IACE,SAAA;EAzGV;EA6GM;IACE,WAAA;EA3GR;EA6GQ;IACE,WAAA;EA3GV;EAmHM;IACE,kBAAA;EAjHR;EAmHQ;IACE,WAAA;IACA,8BAAA;EAjHV;EAmHU;IACE,kBAAA;EAjHZ;EAqHQ;IACE,WAAA;IACA,yBAAA;EAnHV;EAwHQ;IACE,sBAAA;IACA,QAAA;EAtHV;AACF;AA6HA,2EAAA;AACA,wEAAA;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AA5HJ;AA8HI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA5HN;AA8HM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA5HR;AAgII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AA9HN;AAgIM;EACE,aAAA;EACA,QAAA;AA9HR;AAgIQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA9HV;AAgIU;EACE,eAAA;EACA,cAAA;AA9HZ;AAiIU;EACE,yBAAA;AA/HZ;AAkIU;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAhIZ;AAqIM;EACE,aAAA;EACA,oBAAA;AAnIR;AAqIQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAnIV;AAqIU;EACE,mBAAA;AAnIZ;AA0IE;EACE;IACE,sBAAA;IACA,kCAAA;EAxIJ;EA0II;IACE,cAAA;IACA,WAAA;IACA,8BAAA;EAxIN;AACF","sourcesContent":["@charset \"UTF-8\";\n/* ==================== RENDER TASKS STYLES ==================== */\n.tasks-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  /* Header Section */\n  /* No Data State */\n  /* ==================== TABLE VIEW ==================== */\n  /* ==================== GRID VIEW ==================== */\n}\n.tasks-container .tasks-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.tasks-container .tasks-header .tasks-summary {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.tasks-container .tasks-header .tasks-summary p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n.tasks-container .tasks-header .tasks-actions-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n}\n.tasks-container .tasks-header .tasks-actions-right .view-toggles {\n  display: flex;\n  gap: 4px;\n}\n.tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  background-color: transparent;\n  color: #444;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn svg {\n  font-size: 1rem;\n  color: inherit;\n}\n.tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn:hover {\n  background-color: #f3f4f6;\n}\n.tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn.active {\n  background-color: #e5e7eb;\n  color: #222;\n  border-color: #cbd5e1;\n}\n.tasks-container .tasks-header .tasks-actions-right .add-task-btn button {\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 8px 18px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n.tasks-container .tasks-header .tasks-actions-right .add-task-btn button:hover {\n  background: #0052a3;\n}\n.tasks-container .no-data-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 1.5rem;\n  text-align: center;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 16px;\n  border: 2px dashed #cbd5e1;\n  min-height: 200px;\n}\n.tasks-container .no-data-container .no-data-title {\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n.tasks-container .no-data-container .no-data-message {\n  font-size: 1rem;\n  color: #6b7280;\n  max-width: 400px;\n  line-height: 1.5;\n}\n.tasks-container .table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  padding-bottom: 10px;\n}\n.tasks-container .table-responsive::-webkit-scrollbar {\n  height: 6px;\n}\n.tasks-container .table-responsive::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 4px;\n}\n.tasks-container .documents-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  font-size: 0.95rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n.tasks-container .documents-table thead {\n  background-color: #f1f5f9;\n}\n.tasks-container .documents-table thead th {\n  text-align: left;\n  padding: 1rem;\n  color: #111827;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n  font-size: 14px;\n}\n.tasks-container .documents-table thead th.td-th-casedet {\n  font-size: 14px;\n}\n.tasks-container .documents-table tbody tr {\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n}\n.tasks-container .documents-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n.tasks-container .documents-table tbody tr:not(:last-child) td {\n  border-bottom: 1px solid #f1f5f9;\n}\n.tasks-container .documents-table tbody tr td {\n  padding: 0.9rem 1rem;\n  color: #374151;\n  vertical-align: middle;\n  font-size: 14px;\n}\n.tasks-container .documents-table tbody tr td.td-th-casedet {\n  font-size: 14px;\n}\n.tasks-container .documents-table .editdel-table-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n.tasks-container .documents-table .editdel-table-actions button {\n  color: #000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  width: 50px;\n}\n.tasks-container .documents-table .editdel-table-actions button.editbtn:hover {\n  background: var(--container-bg);\n  opacity: 0.9;\n}\n.tasks-container .documents-table .editdel-table-actions button.delbtn:hover {\n  background: var(--container-bg);\n  opacity: 0.9;\n}\n.tasks-container .tasks-grid-layout {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 10px 2px;\n}\n.tasks-container .tasks-grid-layout .modern-task-card {\n  background-color: #fff;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  height: 100%;\n  cursor: pointer;\n  position: relative;\n  /* Status Badge (Top-Right Corner) */\n  /* Header Strip with Actions */\n  /* Content Body */\n}\n.tasks-container .tasks-grid-layout .modern-task-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n.tasks-container .tasks-grid-layout .modern-task-card .task-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 4px 10px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.tasks-container .tasks-grid-layout .modern-task-card .task-badge.new {\n  background-color: darkgreen;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .task-badge.updated {\n  background-color: darkcyan;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .task-badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip {\n  background-color: #f8fafb;\n  padding: 12px 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-bottom: 2px solid #e2e8f0;\n  transition: background 0.3s ease;\n  gap: 10px;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge {\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--primary-color);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.4;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge .type-icon {\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge .title-text {\n  word-break: break-word;\n  color: var(--primary-color);\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill {\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill.new {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .status-pill.updated {\n  background-color: #e0f2fe;\n  color: #075985;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions {\n  display: flex;\n  gap: 6px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn.edit-btn:hover {\n  background: var(--container-bg);\n  opacity: 0.9;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn.delete-btn:hover {\n  background: var(--container-bg);\n  opacity: 0.9;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  /* Horizontal Row for Two Items Side by Side */\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .recurring-info {\n  background-color: #fff7ed;\n  color: #c2410c;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px dashed #fdba74;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal .detail-row-half {\n  flex: 1;\n  min-width: 0;\n}\n@media (max-width: 480px) {\n  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #6b7280;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-label .row-icon {\n  font-size: 0.9rem;\n  color: #9ca3af;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value {\n  font-size: 0.9rem;\n  color: #1f2937;\n  font-weight: 500;\n  padding-left: 2px;\n  line-height: 1.5;\n  word-break: break-word;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge.completed {\n  background-color: #d1fae5;\n  color: #047857;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value .completion-badge.pending {\n  background-color: #fee2e2;\n  color: #b91c1c;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text {\n  color: #4b5563;\n  max-height: 150px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {\n  width: 3px;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;\n  border-radius: 4px;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.8rem;\n  margin-left: 5px;\n  padding: 0;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {\n  text-decoration: underline;\n  color: var(--primary-color);\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text img {\n  max-width: 100%;\n  height: auto;\n}\n.tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text p {\n  margin: 0 0 4px 0;\n}\n\n/* Inline badge for table view */\n.task-badge-inline {\n  padding: 1px 5px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.task-badge-inline::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.task-badge-inline.new {\n  background-color: darkgreen;\n}\n.task-badge-inline.updated {\n  background-color: darkcyan;\n}\n\n/* ==================== ANIMATIONS ==================== */\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes sparkle {\n  0%, 100% {\n    opacity: 0.5;\n    transform: scale(0.8);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n}\n/* ==================== RESPONSIVE STYLES ==================== */\n@media (max-width: 768px) {\n  .tasks-container .tasks-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .tasks-container .tasks-header .tasks-actions-right {\n    margin-left: 0;\n    width: 100%;\n    justify-content: space-between;\n  }\n  .tasks-container .tasks-grid-layout {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip {\n    padding: 12px 16px;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left {\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge {\n    font-size: 0.9rem;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions {\n    gap: 6px;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions .action-btn {\n    width: 30px;\n    height: 30px;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body {\n    padding: 16px;\n    gap: 12px;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal {\n    flex-direction: column;\n    gap: 8px;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row .detail-value.description-text {\n    max-height: 120px;\n  }\n  .tasks-container .documents-table {\n    font-size: 0.85rem;\n  }\n  .tasks-container .documents-table thead th,\n  .tasks-container .documents-table tbody td {\n    padding: 0.75rem 0.5rem;\n  }\n}\n@media (max-width: 480px) {\n  .tasks-container .tasks-header .tasks-summary {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  .tasks-container .tasks-header .tasks-actions-right {\n    flex-direction: column;\n    width: 100%;\n  }\n  .tasks-container .tasks-header .tasks-actions-right .view-toggles {\n    width: 100%;\n    justify-content: stretch;\n  }\n  .tasks-container .tasks-header .tasks-actions-right .view-toggles .toggle-btn {\n    flex: 1;\n  }\n  .tasks-container .tasks-header .tasks-actions-right .add-task-btn {\n    width: 100%;\n  }\n  .tasks-container .tasks-header .tasks-actions-right .add-task-btn button {\n    width: 100%;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip {\n    padding: 10px 14px;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left {\n    width: 100%;\n    justify-content: space-between;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-left .task-title-badge {\n    font-size: 0.85rem;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-header-strip .header-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n  .tasks-container .tasks-grid-layout .modern-task-card .card-content-body .detail-row-horizontal {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n/* ==================== INTEGRATION WITH TAB-CONTENT ==================== */\n/* These styles ensure proper integration when used within tab-content */\n.tab-content .summary.header-actions-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.tab-content .summary.header-actions-container .sum-amount {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.tab-content .summary.header-actions-container .sum-amount p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n.tab-content .summary.header-actions-container .actions-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n}\n.tab-content .summary.header-actions-container .actions-right .view-toggles {\n  display: flex;\n  gap: 4px;\n}\n.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  background-color: transparent;\n  color: #444;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn svg {\n  font-size: 1rem;\n  color: inherit;\n}\n.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn:hover {\n  background-color: #f3f4f6;\n}\n.tab-content .summary.header-actions-container .actions-right .view-toggles .toggle-btn.active {\n  background-color: #e5e7eb;\n  color: #222;\n  border-color: #cbd5e1;\n}\n.tab-content .summary.header-actions-container .actions-right .tab-add {\n  display: flex;\n  justify-content: end;\n}\n.tab-content .summary.header-actions-container .actions-right .tab-add > button {\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 6px 18px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n.tab-content .summary.header-actions-container .actions-right .tab-add > button:hover {\n  background: #0052a3;\n}\n@media (max-width: 600px) {\n  .tab-content .summary.header-actions-container {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n  .tab-content .summary.header-actions-container .actions-right {\n    margin-left: 0;\n    width: 100%;\n    justify-content: space-between;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
